import { Component } from '@angular/core';
import {GoogleAnalyticsService} from '../google-analytics.service';

@Component({
    selector: 'app-about',
    templateUrl: './about.component.html',
    styleUrls: ['./about.component.css'],
    standalone: false
})
export class AboutComponent {

  constructor(public gaService: GoogleAnalyticsService) {
  }

}
